export default "__VITE_ASSET__D6rs66YA__"